{
  "el": {
    "activemodel": {
      "errors": {
        "models": {
          "temporary/contact_form": {
            "attributes": {
              "email": {
                "blank": "Χρειαζόμαστε το E-Mail σας για να απαντήσουμε στο αίτημά σας.",
                "invalid": "Αυτό το E-Mail δεν φαίνεται σωστό. Παρακαλούμε ελέγξτε το."
              },
              "full_name": {
                "blank": "Χρειάζεται να γνωρίζουμε το ονοματεπώνυμό σας, πώς να σας αποκαλούμε;"
              },
              "language": {
                "blank": "Η γλώσσα πρέπει να καθοριστεί"
              },
              "message": {
                "blank": "Πώς μπορούμε να σας βοηθήσουμε;",
                "too_long": {
                  "one": "Εξαντλήσατε τον διαθέσιμο χώρο (1 χαρακτήρας).",
                  "other": "Εξαντλήσατε τον διαθέσιμο χώρο (%{count} χαρακτήρες)."
                }
              }
            }
          }
        }
      }
    }
  },
  "en": {
    "activemodel": {
      "errors": {
        "models": {
          "temporary/contact_form": {
            "attributes": {
              "email": {
                "blank": "We need your email address so we can reply to your request.",
                "invalid": "This email address doesn't seem correct. Please check it."
              },
              "full_name": {
                "blank": "We need to know your name, what should we call you?"
              },
              "language": {
                "blank": "Language must be specified"
              },
              "message": {
                "blank": "How can we help you?",
                "too_long": {
                  "one": "Maximum limit reached (1 character).",
                  "other": "Maximum limit reached (%{count} characters)."
                }
              }
            }
          }
        }
      }
    }
  }
}